<template>
  <v-navigation-drawer
      v-model="app.sidebar.opened"
      app
      right
      temporary
      location="right"
      @click="toggleSideBar()"
      style="overflow: hidden"
  >
    <v-list active-class="text--accent-4" nav dense >
      <v-list-item-subtitle v-show="user.accountId" class="large font-weight-bold" inset>{{ $t('menu') }}</v-list-item-subtitle>
      <v-list-item class="nav-link small " v-show="isStudent || !isTeacher" to="/student/register"><v-list-item-content> {{ $t('register') }}   </v-list-item-content> </v-list-item>
      <v-list-item class="nav-link small " v-show="isStudent || !isTeacher" to="/student/assign"><v-list-item-content>{{ $t('my_class') }}    </v-list-item-content> </v-list-item>
      
      <v-list-item class="nav-link small " v-show="user.accountId" to="/profile" > {{ this.user.username }}</v-list-item>

      <!-- Teacher Menu Group -->
      <v-list-group v-show="isTeacher" prepend-icon="mdi-teach" :value="false" class="pl-2">
        <template v-slot:activator>
          <v-list-item-title>Teacher</v-list-item-title>
        </template>
        <v-list-item to="/teacher/register" dense class="pl-4">
          <v-list-item-content><v-list-item-title>Test Students</v-list-item-title></v-list-item-content>
        </v-list-item>
        <v-list-item to="/teacher/assigns" dense class="pl-4">
          <v-list-item-content><v-list-item-title>Enrolled Students</v-list-item-title></v-list-item-content>
        </v-list-item> 
      </v-list-group>
      
      <!-- Manager Menu Group -->
      <v-list-group v-show="isManager" prepend-icon="mdi-account-tie" :value="false" class="pl-2">
        <template v-slot:activator>
          <v-list-item-title>Manager</v-list-item-title>
        </template>
        <v-list-item to="/manager/register" dense class="pl-4">
          <v-list-item-content><v-list-item-title>Register</v-list-item-title></v-list-item-content>
        </v-list-item>
        <v-list-item to="/manager/assigns" dense class="pl-4">
          <v-list-item-content><v-list-item-title>Assign</v-list-item-title></v-list-item-content>
        </v-list-item>
        <v-list-item to="/manager/accounts" dense class="pl-4">
          <v-list-item-content><v-list-item-title>Account</v-list-item-title></v-list-item-content>
        </v-list-item>
        <v-list-item to="/manager/attends" dense class="pl-4">
          <v-list-item-content><v-list-item-title>Attend</v-list-item-title></v-list-item-content>
        </v-list-item>
        <v-list-item to="/manager/schedule" dense class="pl-4">
          <v-list-item-content><v-list-item-title>Teacher Schedule</v-list-item-title></v-list-item-content>
        </v-list-item>
        <v-list-item to="/manager/message" dense class="pl-4">
          <v-list-item-content><v-list-item-title>Message</v-list-item-title></v-list-item-content>
        </v-list-item>
      </v-list-group>
    </v-list>


    <v-list active-class="text--accent-4" v-show="!isManager && !isTeacher" nav dense>
      <v-list-item-subtitle class="large font-weight-bold" inset>{{ $t('about') }}</v-list-item-subtitle>
      <v-list-item class="nav-link small" to="/main/class-info"><v-list-item-content> {{ $t('how_it_works') }}</v-list-item-content> </v-list-item>
      <v-list-item class="nav-link small" to="/main/guide/register"><v-list-item-content> {{ $t('registration_guide') }} </v-list-item-content> </v-list-item>
      <v-list-item class="nav-link small" to="/main/teacher"><v-list-item-content> {{ $t('teacher_list') }} </v-list-item-content> </v-list-item>
      <v-list-item class="nav-link small" to="/main/content"><v-list-item-content> {{ $t('book_sample') }} </v-list-item-content> </v-list-item>
      <v-list-item class="nav-link small" to="/main/guide/call"><v-list-item-content> {{ $t('app_installation') }} </v-list-item-content> </v-list-item>
    </v-list>
    <v-list active-class="text--accent-4" nav dense>
      <v-list-item-subtitle class="large font-weight-bold" inset>{{ $t('help') }}</v-list-item-subtitle>
      <v-list-item class="nav-link small" v-show="isManager" to="/board/notice"><v-list-item-content> {{ $t('notice') }} </v-list-item-content> </v-list-item>
      <v-list-item class="nav-link small" to="/board/review"><v-list-item-content> {{ $t('review') }} </v-list-item-content> </v-list-item>

      <v-list-item class="nav-link small">
        <v-btn v-if="isManager || isTeacher" @click="loadLanaguageAsync('en')">English</v-btn>
        <v-btn v-if="isManager || isTeacher" @click="loadLanaguageAsync('ko')">한국어</v-btn>
      </v-list-item>

      <v-list-item class="fluid" v-show="!user.accountId " to="/login" style="padding: 0px">
        <v-btn width="100%" color="primary" > {{ $t('login') }}/{{ $t('join') }}</v-btn>
      </v-list-item>
      <v-list-item class=" fluid " v-show="user.accountId" to="/logout" style="padding: 0px">
        <v-btn width="100%" color="primary" >{{ $t('logout') }}</v-btn>
      </v-list-item>

      <v-spacer style="height: 10vh"/>
      <v-list-item class="nav-link small">
        <v-switch
            v-model="$vuetify.theme.dark"
            flat
            :label="$t('dark_mode')"
        ></v-switch>
      </v-list-item>
    </v-list>

  </v-navigation-drawer>
</template>


<script>
import {mapGetters, mapMutations} from 'vuex'
import {loadLanaguageAsync} from "@/locales/i18n";

export default {
  name: 'NavBar',
  data: () => ({
    props: false,
    open: ['']
  }),
  computed: {
    ...mapGetters(['app','user','isStudent','isManager','isTeacher','isMobile']),
    classObj() {
      return {
        collapse: !this.app.sidebar.opened,
        show: this.app.sidebar.opened
      }
    }
  },
  created() {
    this.props = false;
  },
  mounted() { },
  methods: {
    loadLanaguageAsync,
    ...mapMutations(['SET_LANG']),
    openWindow(link) {
      this.$openWindow(link, 'book')
    },
    showMenuOfRole(menuRole){
      return this.user.accountRoles != null
          ? this.user.accountRoles.map(ar => ar.roleType).includes(menuRole)
          : false
    },
    showStudentMenu(menuRole){
      if (this.user.accountRoles != null
          && this.user.accountRoles.map(ar => ar.roleType).includes(menuRole)
          && this.user.accountRoles.length === 1) {
        return true
      }
      return false
      // return this.user.accountRoles != null
      //     ? this.user.accountRoles.map(ar => ar.roleType).includes(menuRole)
      //     : false
    },
    toggleSideBar() {
      this.$store.dispatch('toggleSideBar')
    },
    async logout() {
      await this.$store.dispatch('logout')
      this.$router.replace('/')
      this.$router.go();
    },
  }
}
</script>
